import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "../Aibox/AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addHikvision, addLiveViewCamera, addSigfoxAPI, aiboxLogin, dahuaLogin, hikvisionLogin, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/pleasewait.json'
import successAnim from '../../../../../../assets/animations/success.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import { SelectButton } from 'primereact/selectbutton';
import { protocol } from 'socket.io-client';

import loggingInAnim from '../../../../../../assets/animations/pleasewait.json'
import { Dialog } from 'primereact/dialog';

const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const LiveViewCameraForm = ({ setShowVirtualSource, fetchVirtualSources, setShowSuccess, setShowFail, setFailMessage }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to add camera, please wait...")
    const [linkTitle, setLinkTitle] = useState("Camera added successfully!")
    const [loading, setLoading] = useState(false)

    const [cameraName, setCameraName] = useState("")

    const userID = useSelector(state => state.auth.userID);

    const [failReason, setFailReason] = useState("")
    const [streamType, setStreamType] = useState("Main stream")

    const [showLoggingIn, setShowLoggingIn] = useState(false)
    const [showAddingCams, setShowAddingCams] = useState(false)
    const [showAddingGeneric, setShowAddingGeneric] = useState(false)

    const [genericRtspURL, setGenericRtspURL] = useState("")
    const [selectedChannels, setSelectedChannels] = useState([]);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [rtspPortState, dispatchRTSPPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };

    const rtspChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        setGenericRtspURL(value)
    };

    const cameraNameChangeHandler = (e) => {
        const value = e.target.value;

        setCameraName(value)
    };

    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const rtspPortChangeHandler = (event) => {
        dispatchRTSPPortState({ type: 'USER_INPUT', val: event.target.value });
    }


    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const HandleAddCamera = async (type) => {
        setShowLoggingIn(true)
        if (type == "DAHUA"){
            const body = {
                deviceIp: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await dahuaLogin(apiData, body, dispatch)
            if (response.success){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${portState.value}/cam/realmonitor?channel=1&subtype=${streamType == "Main stream" ? 0 : 1}`
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        {
                            name: cameraName,
                            rtspURL: rtspURL,
                            type: "DAHUA",
                            defaultPinned: 0
                        }
                    ]
                };
                const addResponse = await addLiveViewCamera(apiData, body, dispatch)
                if (addResponse.success){
                    setShowLoggingIn(false)
                    //show success
                    HandleCloseModal();
                    setShowSuccess(true)
                    fetchVirtualSources();
                } else {
                    setShowLoggingIn(false)
                    setShowFail(true)
                    HandleCloseModal();
                    setFailMessage("Failed to add live view camera, please check your details and try again")
                }
            } else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Dahua, please check your details and try again")
                setShowFail(true)
            }
        } else if (type == "HIKVISION"){
            const body = {
                protocol: "http",
                hostName: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await hikvisionLogin(apiData, body, dispatch)
            if (response.success){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${rtspPortState.value}/streaming/channels/10${streamType == "Main stream" ? 1 : 2}`
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        {
                            name: cameraName,
                            rtspURL: rtspURL,
                            type: "HIKVISION",
                            defaultPinned: 0
                        }
                    ]
                };
                const addResponse = await addLiveViewCamera(apiData, body, dispatch)
                if (addResponse.success){
                    setShowLoggingIn(false)
                    //show success
                    HandleCloseModal();
                    setShowSuccess(true)
                    fetchVirtualSources();
                } else {
                    setShowLoggingIn(false)
                    setShowFail(true)
                    HandleCloseModal();
                    setFailMessage("Failed to add live view camera, please check your details and try again")
                }
            } else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Hikvision, please check your details and try again")
                setShowFail(true)
            }
        }
    }

    const toggleButton = (index) => {
    setSelectedChannels(prev => {
      if (prev.includes(index)) {
        return prev.filter(i => i !== index); 
      } else {
        return [...prev, index]; 
      }
    });
    };

    const HandleAddRTSP = async () => {
        setShowAddingGeneric(true)
        const body = {
                siteUUID: DeviceUUID,
                cameras: [
                    {
                        name: cameraName,
                        rtspURL: genericRtspURL,
                        type: "GENERIC",
                        defaultPinned: 0
                    }
                ]
            };
            const addResponse = await addLiveViewCamera(apiData, body, dispatch)
            if (addResponse.success){
                setShowAddingGeneric(false)
                HandleCloseModal();
                setShowSuccess(true)
                fetchVirtualSources();
            } else {
                setShowAddingGeneric(false)
                setShowFail(true)
                HandleCloseModal();
                setFailMessage("Failed to add camera, please check try again")
            }
    }

    const HandleAddChannels = async (type) => {
        setShowAddingCams(true);
        let addResponseCount = 0;

        //Check which button was pressed first - this if Dahua else ...

        for (let channel of selectedChannels) {
            if (type == "DAHUA"){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${portState.value}/cam/realmonitor?channel=${channel}&subtype=${streamType === "Main stream" ? 0 : 1}`;
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        { name: `${cameraName} - Cam ${channel}`, rtspURL, type: "DAHUA", defaultPinned: 0 }
                    ]
                };

                try {
                    const addResponse = await addLiveViewCamera(apiData, body, dispatch);
                    if (addResponse) addResponseCount++;
                } catch (err) {
                    console.error(`Failed to add camera for channel ${channel}`, err);
                }
            }
            if (type == "HIKVISION"){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${rtspPortState.value}/streaming/channels/${channel}0${streamType === "Main stream" ? 1 : 2}`;
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        { name: `${cameraName} - Cam ${channel}`, rtspURL, type: "HIKVISION", defaultPinned: 0 }
                    ]
                };

                try {
                    const addResponse = await addLiveViewCamera(apiData, body, dispatch);
                    if (addResponse) addResponseCount++;
                } catch (err) {
                    console.error(`Failed to add camera for channel ${channel}`, err);
                }
            }

        }

        setShowAddingCams(false);

        if (addResponseCount === selectedChannels.length) {
            fetchVirtualSources();
            HandleCloseModal();
            setShowSuccess(true);
        }
    };


    const HandleAddNVR = async (type) => {
        setShowLoggingIn(true)
        if (type == "DAHUA"){
            const body = {
                deviceIp: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await dahuaLogin(apiData, body, dispatch)
            if (response.success){
                setShowLoggingIn(false)
                setModalPageIndex(12)
            } 
            else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Dahua, please check your details and try again")
                setShowFail(true)
            }
        }
        if (type == "HIKVISION"){
            const body = {
                protocol: "http",
                hostName: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await hikvisionLogin(apiData, body, dispatch)
            if (response.success){
                setShowLoggingIn(false)
                setModalPageIndex(23) //choose channels
            } 
            else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Hikvision, please check your details and try again")
                setShowFail(true)
            }
        }
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h2 style={{color:"#6e6e6e"}}>Which type of camera</h2>
                        <br></br>
                        <Button label='Dahua' severity='info' style={{width: "150px"}} onClick={() => setModalPageIndex(1)}/>
                        <br/>
                        <Button label='Dahua NVR' severity='info' style={{width: "150px"}} onClick={() => setModalPageIndex(11)}/>
                        <br/>
                        <Button label='Hikvision' severity='info' style={{width: "150px"}} onClick={() => setModalPageIndex(20)}/>
                        <br/>
                        <Button label='Hikvision NVR' severity='info' style={{width: "150px"}} onClick={() => setModalPageIndex(21)}/>
                        <br/>
                        <Button label='RTSP Stream' severity='info' style={{width: "150px"}} onClick={() => setModalPageIndex(10)}/>
                    </div>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add liveview camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddCamera("DAHUA")}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
                break;
            case 20:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Hikvision camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP Port"}
                                ref={portRef}
                                id="rtspport"
                                value={rtspPortState.value}
                                onChange={rtspPortChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddCamera("HIKVISION")}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
            break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )
                HandleShowModal();
                break; 
            
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Camera added successfully!</h3>
                    <br />
                    <Button
                        onClick={() => {HandleCloseModal(); fetchVirtualSources();}}
                        style={{ width: "100%" }}
                        severity='secondary'
                        label='Close'
                    />
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Failed to add camera</h3>
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failReason}</h3>
                    <br />
                              <Button onClick={HandleCloseModal} label="Close" severity='secondary'/>
                    
                </div>
            )
            HandleShowModal();
        break; 
        case 10:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add liveview camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Stream URL"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={genericRtspURL}
                                onChange={rtspChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={HandleAddRTSP}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
                break;
        case 11:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Dahua NVR</h2>
                            <p style={{color:"#6e6e6e"}}>Link your Dahua NVR by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"NVR name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddNVR("DAHUA")}>
                                {loading ? "Checking NVR..." : "Next"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
                break;
        case 21:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Hikvision NVR</h2>
                            <p style={{color:"#6e6e6e"}}>Link your Hikvision NVR by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"NVR name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP Port"}
                                ref={portRef}
                                id="rtspport"
                                value={rtspPortState.value}
                                onChange={rtspPortChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddNVR("HIKVISION")}>
                                {loading ? "Checking NVR..." : "Next"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
            break;
        case 12: 
                setModalComponent(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column', 
                        alignItems: 'center',   
                        justifyContent: 'center',
                    }}>
                        <p>Which channels would you like to add?</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
                            {Array.from({ length: 16 }).map((_, i) => (
                                <Button
                                    key={`${i + 1}`}
                                    label={`${i + 1}`}
                                    className={selectedChannels.includes(`${i + 1}`) ? 'p-button-success' : 'p-button-outlined'}
                                    onClick={() => toggleButton(`${i + 1}`)}
                                />
                            ))}
                        </div>
                        
                        <br/>
                        <Button label='Add channels' disabled={selectedChannels.length == 0} onClick={() => HandleAddChannels("DAHUA")}/>
                    </div>
                )
                HandleShowModal();
            break;
            case 23: 
                setModalComponent(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column', 
                        alignItems: 'center',   
                        justifyContent: 'center',
                    }}>
                        <p>Which channels would you like to add?</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
                            {Array.from({ length: 16 }).map((_, i) => (
                                <Button
                                    key={`${i + 1}`}
                                    label={`${i + 1}`}
                                    className={selectedChannels.includes(`${i + 1}`) ? 'p-button-success' : 'p-button-outlined'}
                                    onClick={() => toggleButton(`${i + 1}`)}
                                />
                            ))}
                        </div>
                        
                        <br/>
                        <Button label='Add channels' disabled={selectedChannels.length == 0} onClick={() => HandleAddChannels("HIKVISION")}/>
                    </div>
                )
                HandleShowModal();
            break;
        
        }
    }, [modalPageIndex, ipAddressState, portState, rtspPortState, usernameState, passwordState, linkMessage, linkTitle, message, failReason, cameraName, streamType, genericRtspURL, selectedChannels]);

    return (
        <>

        <Modal ref={ModalDialog} title={"Add liveview camera"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

        <Dialog
                header="Logging in"
                visible={showLoggingIn}
                style={{ width: "40vw" }}
                onHide={() => setShowLoggingIn(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={loggingInAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Attempting to connect, please wait...`}</h3>
                    <br />
                    
                </div>
            </Dialog>

            <Dialog
                header="Please wait"
                visible={showAddingGeneric}
                style={{ width: "40vw" }}
                onHide={() => setShowAddingGeneric(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={loggingInAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Adding camera, please wait...`}</h3>
                    <br />
                    
                </div>
            </Dialog>

            
        </>
    )
}

export default LiveViewCameraForm;